var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9.467,
    viewBox: "0 0 16 9.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5559.364 279)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.636,14.969l6.747-6.747,1.253,1.253-8,8.213-8-8.213L7.889,8.222Z",
    transform: "translate(-5566 -287.222)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.636,12.636,12.136,16l-3.5-3.364Z",
    transform: "translate(-5563.436 -291.222)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.7745ec37a4e9ec7121becfc5e2baddd2.svg";
export { ForwardRef as ReactComponent };